import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Guarantee() {
  const [open, setOpen] = useState(false);
  return <section className="px-5 py-6 bg-white" data-id="element-61">
      <div className="max-w-md mx-auto border border-gray-200 rounded-xl overflow-hidden" data-id="element-62">
        <button onClick={() => setOpen(v => !v)} aria-expanded={open} className="w-full flex items-center justify-between px-4 py-3 text-left focus:outline-none" data-id="element-63">
          <span className="font-bold text-gray-900" data-id="element-64">🔒 Garantía de 7 días</span>
          <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} data-id="element-65" />
        </button>
        <AnimatePresence initial={false} data-id="element-66">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-67">
              <p className="px-4 pb-4 text-sm text-gray-600 leading-relaxed" data-id="element-68">
                Si por cualquier motivo sentís que no es lo que esperabas,
                escribinos y te devolvemos el 100% de tu dinero. Sin preguntas.
                Sin formularios complicados. Sin vueltas.
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}